import React from 'react';
import { ReactComponent as FigPresentationChart01Component } from './FigPresentationChart01.svg';

const FigPresentationChart01 = (props) => (
  <FigPresentationChart01Component {...props} />
);

export default FigPresentationChart01;
